import * as React from 'react'
// libs
import { useRouter } from 'hooks/useRouter'
// components
import { DetailsButton } from 'components/UI'
// context
import { DataHubAPIContext } from 'containers/DataHub/layers/API'
// constants
import { Modals } from 'constants/index'
// views
import { Header, Preview, ReportIcon, Wrapper } from './views'
// hooks
import { useCurrentUser, useShowModal } from 'hooks/index'
// themes
import { EllipsizedText } from 'themes/views/generic'
// types
import { IPowerBiReport } from 'types/graphql'

// types
interface Props {
  report: IPowerBiReport
  standard?: boolean
}

const Card: React.FC<Props> = ({ report, standard }) => {
  const { cloneReport, deleteReport } = React.useContext(DataHubAPIContext)

  const router = useRouter()

  const { showModal } = useShowModal({ modalType: Modals.CONFIRM_DELETE_MODAL })
  const { showModal: showRenameModal } = useShowModal({ modalType: Modals.REPORT_UPDATE_MODAL })
  const { showModal: showPermissionsModal } = useShowModal({ modalType: Modals.REPORT_PERMISSIONS_MODAL })

  const {
    permissionsFromSecurityGroups: { reportingClone, reportingDelete, reportingEdit, manageReports }
  } = useCurrentUser()

  // methods
  const onCloneButtonClick = () => cloneReport(report.id, report.workspaceId)

  const onDeleteButtonClick = () =>
    showModal({
      name: `Delete ${report.name}`,
      text: 'Are you sure want to delete this report?',
      width: 'sm',
      handleConfirm: () => deleteReport(report.id)
    })

  const onEditButtonClick = () => {
    router.push({
      pathname: `/data-hub/report/edit/${report.id}/workspace/${report.workspaceId}/name/${report.customName || report.name}`
    })
  }

  const onReportClick = () => {
    router.push({
      pathname: `/data-hub/report/${report.id}/workspace/${report.workspaceId}/name/${report.customName || report.name}`
    })
  }

  const onRenameButtonClick = () => showRenameModal({ report })

  const onManageAccessClick = () => showPermissionsModal({ report })

  const hasStandardAccess = reportingClone || manageReports
  const hasNonStandardAccess = reportingClone || reportingDelete || reportingEdit

  const showMenu = standard ? hasStandardAccess : hasNonStandardAccess

  return (
    <Wrapper>
      <Header>
        <EllipsizedText>{report.customName || report.name}</EllipsizedText>
        {showMenu && (
          <DetailsButton preset='light'>
            {reportingEdit && !standard && <span onClick={onEditButtonClick}>Edit</span>}
            {reportingClone && <span onClick={onCloneButtonClick}>Clone</span>}
            {reportingDelete && !standard && <span onClick={onDeleteButtonClick}>Delete</span>}
            {reportingEdit && !standard && <span onClick={onRenameButtonClick}>Rename</span>}
            {manageReports && <span onClick={onManageAccessClick}>Manage Access</span>}
          </DetailsButton>
        )}
      </Header>
      <Preview onClick={onReportClick}>
        <ReportIcon />
      </Preview>
    </Wrapper>
  )
}

export default Card
